import { createContext } from 'react';

export type ConfluenceExperimentsContextType = {
	getPageRecommendationData: () => {
		pageRecommendationData: PageRecommendationData | undefined;
		recommendedPageQueryStatus: {
			loading: boolean;
			error: Error | undefined;
		};
		hoverPageCardQueryStatus: {
			loading: boolean;
			error: Error | undefined;
		};
	};
};

export type PageRecommendationData = {
	pageOwner: {
		name: string;
		avatarUrl: string;
	};
	page: {
		title: string;
		url: string;
	};
};

const defaultData = {
	loading: false,
	error: undefined,
};

export const ConfluenceExperimentsContext = createContext<ConfluenceExperimentsContextType>({
	getPageRecommendationData: () => ({
		pageRecommendationData: undefined,
		recommendedPageQueryStatus: defaultData,
		hoverPageCardQueryStatus: defaultData,
	}),
});
